var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000","fillRule":"evenodd","d":"M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25zm0-3c12.15 0 22-9.85 22-22S37.15 3 25 3 3 12.85 3 25s9.85 22 22 22zm1.815-11V24.999h3.254l.431-3.791h-3.685l.005-1.898c0-.989.1-1.518 1.623-1.518h2.034V14h-3.255c-3.91 0-5.285 1.84-5.285 4.932v2.276H19.5v3.791h2.437V36h4.878zm0 0"}));
}

FacebookIcon.defaultProps = {"viewBox":"0 0 50 50"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
